import React, { useState, useEffect } from 'react'
import Accordion from 'britive-design-system/core/components/accordion'
import Checkbox from 'britive-design-system/core/components/checkbox'
import RadioGroup from 'britive-design-system/core/components/radio'
import Dialog from 'britive-design-system/core/components/dialog'

import SectionTitle from '../SectionTitle'
import { sectionTitle } from '../constants'

const styles = {
  container: {
    marginLeft: '20px',
  },
}

const ManagerApprovalSettings = ({
  required = false,
  condition = 'Any',
  updateSettings,
  isAssociationApproversEmpty = false,
}) => {
  const [value, setValue] = useState('')
  const [dialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    setValue(condition)
  }, [condition])

  const handleCheckboxChange = e => {
    const isChecked = e.target.checked
    if (!isChecked) {
      setValue('Any') // Reset to 'Any' if approval is not mandatory
    }
    // Update settings with the new state
    updateSettings({
      managerApproval: {
        required: isChecked,
        condition: !isChecked ? 'Any' : value,
      },
    })
  }

  const handleRadioChange = e => {
    const selectedValue = e.target.value
    setValue(selectedValue)

    if (selectedValue === 'Manager' && !isAssociationApproversEmpty) {
      // If 'Manager' is selected and there are association approvers, show confirmation dialog
      setDialogOpen(true)
      return
    } else {
      updateSettings({
        managerApproval: {
          required,
          condition: selectedValue,
        },
      })
    }
  }

  const handleDeleteApprovers = () => {
    let valueToSet = 'Manager'
    setDialogOpen(false)
    setValue(valueToSet)

    updateSettings({
      managerApproval: {
        required,
        condition: valueToSet,
      },
    })
  }

  const radioOptions = [
    {
      label: (
        <>
          Manager <strong>OR</strong> Approvers
        </>
      ),
      value: 'Any',
      disabled: !required,
    },
    {
      label: (
        <>
          Manager <strong>AND</strong> Approvers
        </>
      ),
      value: 'All',
      disabled: !required,
    },
    {
      label: (
        <>
          Manager <strong>Only</strong>
        </>
      ),
      value: 'Manager',
      disabled: !required,
    },
  ]

  return (
    <Accordion expanded title={<SectionTitle {...sectionTitle.managerApproval} />}>
      <div style={styles.container}>
        <div style={{ position: 'relative' }}>
          <Checkbox
            name="required"
            label="Manager Approval"
            checked={required}
            onChange={handleCheckboxChange}
          />
        </div>
        <br />
        <div style={styles.container}>
          <RadioGroup
            name="approvalType"
            label=""
            defaultValue={!required ? '' : value}
            options={radioOptions}
            direction="vertical"
            onChange={handleRadioChange}
          />
        </div>
      </div>
      {dialogOpen && (
        <Dialog
          width={464}
          height={278}
          type="alert"
          title={''}
          message={
            <>
              With <strong>Manager Only</strong> approval selected, any Association
              Approvers assigned will not be part of the approval flow.
            </>
          }
          primaryButtonText={'Ok'}
          onSubmit={handleDeleteApprovers}
          onCancel={() => {
            let newValue = condition || 'Any'
            setValue(newValue)
            setDialogOpen(false)
          }}
        />
      )}
    </Accordion>
  )
}

export default React.memo(ManagerApprovalSettings)
